import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useState } from "react";

type Props = {
  description?: string;
  disabled?: boolean;
  onDelete(): void;
};

const DeleteDataItemDialog = ({ description = "this", disabled = false, onDelete }: Props) => {
  const [visible, setVisible] = useState(false);

  const toggleDialog = (e: any) => {
    e.preventDefault();
    setVisible(!visible);
  };

  const handleDelete = (e: any) => {
    onDelete(); // Call the delete function passed as prop
    toggleDialog(e); // Close the dialog
  };

  return (
    <>
      <Button
        onClick={toggleDialog}
        disabled={disabled}
        icon="trash"
        size="small"
        themeColor="primary"
        fillMode="outline"
        title="Delete"
      />

      {visible && (
        <Dialog title={"Confirm Deletion"} onClose={toggleDialog}>
          <p style={{ margin: "25px", textAlign: "center" }}>
            Are you sure you want to delete {description}?
          </p>
          <DialogActionsBar>
            <Button size="small" onClick={toggleDialog}>
              Cancel
            </Button>
            <Button size="small" themeColor="primary" onClick={handleDelete}>
              Confirm
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}
    </>
  );
};

export default DeleteDataItemDialog;
